<div class="w-100 flex-col" >
  <table mat-table [dataSource]="dataSource" matSort matSortActive="buyerFullName" matSortDirection="asc" class="w-100 representationsContainer table-stack-sm">
    <ng-container matColumnDef="buyerFullName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="stack-full"> Buyer</th>
      <td mat-cell *matCellDef="let representation" class="stack-full stack-strong"> {{representation.buyerFullName}} </td>
    </ng-container>
    <ng-container matColumnDef="header">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="stack-last"> Property</th>
      <td mat-cell *matCellDef="let representation" class="stack-last" data-label="Property"> <a [routerLink]="['/properties', representation.propertyId]" class="primary-color" matTooltip="See listing" >{{representation.header}}</a> </td>
    </ng-container>
    <ng-container matColumnDef="displayConfirmed">
      <th mat-header-cell *matHeaderCellDef> Confirmed at</th>
      <td mat-cell *matCellDef="let representation"> {{representation.displayConfirmed}} </td>
    </ng-container>
    <ng-container matColumnDef="displayStatus">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Status</th>
      <td mat-cell *matCellDef="let representation"> {{representation.displayStatus}} </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let document; columns: displayedColumns;"></tr>
  </table>
</div>